import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaSignOutAlt, FaSearch, FaCog, FaRegSmile, FaTimes } from 'react-icons/fa';
import { auth, db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import CustomHeader from './CustomHeader';
import { Button, Modal, Box, Typography, IconButton } from '@mui/material';
import { styled } from '@mui/system';
import './Home.css';
import googlePlayImage from './google.b20c07ec720bfa73a943.webp';

const StyledBox = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: '800px',
  backgroundColor: '#fff',
  border: '2px solid #2A9D8E',
  boxShadow: 24,
  borderRadius: '10px',
  padding: theme.spacing(4),
  textAlign: 'center',
  maxHeight: '80vh',
  overflowY: 'auto',
  '@media (max-width: 768px)': {
    width: '95%',  
    maxWidth: '95%',
  },
}));

const StyledButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(2),
  backgroundColor: '#2A9D8E',
  color: '#fff',
  '&:hover': {
    backgroundColor: '#21867A',
  },
}));

const SecondaryButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(2),
  backgroundColor: '#333',
  color: '#fff',
  '&:hover': {
    backgroundColor: '#555',
  },
}));

const CloseButton = styled(IconButton)({
  position: 'absolute',
  top: 10,
  right: 18,
  color: '#FF4C4D',
});

const Home = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAssinatura = async () => {
      const user = auth.currentUser;
      if (user) {
        const cuidadorRef = doc(db, 'cuidadores', user.uid);
        const docSnap = await getDoc(cuidadorRef);
        if (docSnap.exists()) {
          const cuidadorData = docSnap.data();
          const tipodeconta = cuidadorData.tipodeconta;

          console.log("Valor de 'tipodeconta':", tipodeconta);

          // Abre o modal se o tipo de conta for "Sem Plano", vazia ou não existir
          if (!tipodeconta || tipodeconta === 'Sem Plano') {
            setOpen(true);
          }
        } else {
          console.error('Nenhum documento encontrado!');
        }
      } else {
        console.error('Usuário não autenticado!');
      }
    };

    checkAssinatura();
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const handleLogout = () => {
    auth.signOut();
    navigate('/');
  };

  const navigateToMinhaConta = () => {
    navigate('/minha-conta');
  };

  return (
    <>
      <div className="home-container">
        <CustomHeader />
        <div className="home-content">
          <h1 className="home-title">Bem-vindo ao Carey App</h1>
          <div className="button-grid">
            <div
              className="card highlighted-card"
              onClick={() => navigate('/buscar-vagas')}
              style={{
                backgroundColor: '#2A9D8E',
                color: 'white',
                padding: '20px',
                margin: '10px',
                borderRadius: '10px',
                textAlign: 'center',
                boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                border: '1px solid #e0e0e0',
                transition: 'transform 0.3s, box-shadow 0.3s',
                cursor: 'pointer',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#8BD3CB';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#2A9D8E';
              }}
            >
              <FaSearch size={40} className="fa-icon" style={{ color: 'white' }} />
              <p className="card-text" style={{ marginTop: '10px', fontSize: '1.2em', color: 'white' }}>Buscar Vagas</p>
            </div>
            <div
              className="card"
              onClick={navigateToMinhaConta}
              style={{
                padding: '20px',
                margin: '10px',
                backgroundColor: '#ffffff',
                borderRadius: '10px',
                textAlign: 'center',
                boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                border: '1px solid #e0e0e0',
                transition: 'transform 0.3s, box-shadow 0.3s',
                cursor: 'pointer',
              }}
            >
              <FaCog size={40} className="fa-icon" style={{ color: '#2A9D8E' }} />
              <p className="card-text" style={{ marginTop: '10px', fontSize: '1.2em', color: '#2A9D8E' }}>Minha Conta</p>
            </div>
          </div>
          <button
            className="logout-button"
            onClick={handleLogout}
            style={{
              marginTop: '40px',
              padding: '10px 20px',
              backgroundColor: '#FF4C4D',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '1.2em',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '200px',
              marginLeft: 'auto',
              marginRight: 'auto',
              transition: 'background-color 0.3s',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#cc3b3c';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#FF4C4D';
            }}
          >
            <FaSignOutAlt style={{ marginRight: '10px' }} /> Sair
          </button>
        </div>
      </div>
      
    <Modal
  open={open}
  onClose={handleClose}
  aria-labelledby="modal-title"
  aria-describedby="modal-description"
>
  <StyledBox>
    <CloseButton onClick={handleClose}>
      <FaTimes />
    </CloseButton>
    <FaRegSmile size={40} color="#FF4C4D" style={{ marginBottom: '10px' }} />
    <Typography id="modal-title" variant="h6" component="h2" gutterBottom>
      Olá, seja muito bem-vindo ao Carey App!
    </Typography>
    <Typography id="modal-description" sx={{ mt: 2 }}>
      Aqui você se conecta com famílias que buscam cuidadores qualificados e confiáveis para seus entes queridos. Seja parte de uma comunidade de profissionais cuidadosos e dedicados, com segurança e suporte contínuo.
    </Typography>
    <Typography sx={{ mt: 2 }}>
      <strong>Passo 1:</strong> Para entrar em contato com as famílias e aproveitar todas as funcionalidades, relatórios e benefícios que o app oferece, você precisa ter uma assinatura válida.
    </Typography>
    <StyledButton variant="contained" fullWidth onClick={navigateToMinhaConta}>
      Gerenciar Assinaturas
    </StyledButton>
    <Typography sx={{ mt: 2 }}>
      <strong>Passo 2:</strong> Após obter uma assinatura válida, só falta você baixar o app :)
    </Typography>
    <Button
      variant="text"
      fullWidth
      sx={{ mt: 2 }}
      onClick={() => window.open('https://play.google.com/store/apps/details?id=com.carey.appy.CareyAppCuidadores', '_blank')}
    >
      <img src={googlePlayImage} alt="Baixar no Google Play" style={{ maxWidth: '220px', width: '100%' }} />
    </Button>
    <Typography sx={{ mt: 2 }}>
      <strong>Passo 3:</strong> Envie seus documentos e verifique sua conta para garantir que você está pronto para começar a trabalhar com segurança e confiança.
    </Typography>
    <Typography sx={{ mt: 2, fontWeight: 'bold' }}>
      Pronto! Agora você pode se comunicar com os profissionais e escolher quem irá atender às suas necessidades.
    </Typography>
    <Typography sx={{ mt: 2, fontStyle: 'italic' }}>
      Recomendamos que todo contato seja feito dentro do app para sua segurança! Temos todas as ferramentas necessárias para isso: mensagens de texto, solicitação de antecedentes, chamadas de vídeo e muito mais!
    </Typography>
    <SecondaryButton onClick={handleClose} fullWidth>
      Primeiro quero conhecer melhor o app
    </SecondaryButton>
  </StyledBox>
</Modal>

    </>
  );
};

export default Home;
